(function ($, document, window) {
    'use strict';

    $(function () {
        const $inPage = $('.js-in-page');
        if (!$inPage.length) return;

        const $banner = $('.js-banner');
        const $footer = $('.js-site-footer');
        const lgBreakpoint = getComputedStyle(document.documentElement).getPropertyValue('--break-grid-lg').trim();
        const inPageHeightRem = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--in-page-height').trim());
        const inPageHeight = inPageHeightRem * parseFloat(getComputedStyle(document.documentElement).fontSize);
        const adminBarHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--wp-admin--admin-bar--height').trim()) || 0;
        const matchMedia = window.matchMedia(`(max-width: ${lgBreakpoint})`);
        const visibleClass = 'is-visible';

        function handleMatchMedia(e) {
            if (!e.matches) {
                $inPage.removeClass(visibleClass);
            } else {
                handleInPageVisibility();
            }
        }

        function handleInPageVisibility() {
            if (!matchMedia.matches) {
                return;
            }

            const scrollTop = $(window).scrollTop();
            const bannerBottom = $banner.offset().top + $banner.outerHeight();
            const footerTop = $footer.offset().top;

            // If the scroll position is greater than the banner bottom and the scroll position plus the in-page height is less than the footer top, then show the in-page.
            if (scrollTop >= bannerBottom && scrollTop + inPageHeight <= footerTop) {
                $inPage.addClass(visibleClass).attr('aria-hidden', 'false');
            } else {
                $inPage.removeClass(visibleClass).attr('aria-hidden', 'true');
            }
        }

        function highlightMenuItem(id) {
            const inPageJumpTrigger = $('.js-in-page-jump-label');
            const inPageList = $('.js-in-page-list');
            const currentClassName = 'in-page__link--active';

            if ('undefined' !== typeof id && '' !== id) {
                const text = inPageList.find('a[href="#' + id + '"]').text();

                inPageList.find(`.${currentClassName}`).removeClass(currentClassName);
                inPageList.find('a[href="#' + id + '"]').addClass(currentClassName);

                if (text !== '') {
                    inPageJumpTrigger.text(text);
                } else {
                    inPageJumpTrigger.text('Jump To');
                }
            }
        }

        function registerWaypoints() {
            var $section = $('[data-anchor]');
            const totalHeight = inPageHeight + adminBarHeight;

            $section.each(function () {
                var id = $(this).attr('id');

                $(this).waypoint({
                    handler: function (direction) {
                        if ('down' === direction) {
                            highlightMenuItem(id);
                        }
                    },
                    offset: totalHeight
                });

                $(this).waypoint({
                    handler: function (direction) {
                        if ('up' === direction) {
                            highlightMenuItem(id);
                        }
                    },
                    offset: function () {
                        return -(this.element.clientHeight - totalHeight);
                    }
                });
            });
        }

        function scrollActiveItemIntoView(activeLink) {
            const container = document.querySelector('.js-in-page-list');
            if (container && activeLink) {
                const containerRect = container.getBoundingClientRect();
                const activeLinkRect = activeLink.getBoundingClientRect();
                const offset = activeLinkRect.left - containerRect.left;
                container.scrollBy({
                    left: offset,
                    behavior: 'smooth'
                });
            }
        }

        function toggleInPageList() {
            const button = document.querySelector('.js-in-page-jump');
            const hider = document.querySelector('.js-in-page-hider');
            const links = document.querySelectorAll('.js-in-page-link');

            button.addEventListener('click', (ev) => {
                ev.preventDefault();
                button.blur();
                hider.classList.toggle('in-page__hider--active');
            });

            links.forEach((link) => {
                link.addEventListener('click', (ev) => {
                    hider.classList.remove('in-page__hider--active');
                    scrollActiveItemIntoView(link);
                });
            });
        }

        if (document.querySelector('.js-in-page-jump')) {
            registerWaypoints();
            toggleInPageList();
        }

        matchMedia.addEventListener('change', handleMatchMedia);
        handleMatchMedia(matchMedia);

        $(window).on('scroll resize', handleInPageVisibility);
        handleInPageVisibility();
    });
})(jQuery, document, window);
